var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.504914 76.507429l768 768a42.678857 42.678857 0 0 1-60.342857 60.342857l-768-768a42.678857 42.678857 0 1 1 60.342857-60.342857z m-21.284571 175.177142L644.933486 844.434286a127.634286 127.634286 0 0 1-46.957715 8.886857H171.333486a128 128 0 0 1-128-128V298.678857c0-16.603429 3.145143-32.438857 8.886857-46.957714z m865.755428 39.094858c35.364571 0 64 28.635429 64 64v314.441142a64 64 0 0 1-111.835428 42.532572l-90.697143-102.070857a42.678857 42.678857 0 0 1-10.788571-28.342857v-138.678858c0-10.459429 3.84-20.516571 10.788571-28.342857l90.697143-102.034285a64 64 0 0 1 47.835428-21.504z m-320-120.100572a128 128 0 0 1 128 128v351.707429L246.158629 170.642286h351.817142z",
    fill: "#F5222D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraOff);
export default __webpack_public_path__ + "static/media/ic_camera_off.133057f8b64381fabd1a001fdef4f256.svg";
export { ForwardRef as ReactComponent };